import React from 'react'
import PropTypes from 'prop-types'
import {Notes} from "./Notes";
import sessionStore from "../../services/session/SessionStore"
import {Spinner} from "../../components";
import {WithNoteData} from "./WithNoteData";
import {UncontrolledPopover, PopoverHeader, PopoverBody} from "reactstrap";

/**
 * Renders a button prop that, when clicked, shows a popover with notes (See Notes component)
 * Button accepts isLoading and notes props (e.g. for displaying note count)
 * Used by reviews/listings at time of writing
 **/
export class NoteActionButton extends React.Component {
  static propTypes = {
    noteType: PropTypes.string.isRequired,
    entityId: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.string),
    button: PropTypes.any // component. passed {isLoading, notes} props
  }

  static defaultProps = {
    button: () => <a tabIndex={"0"}>Notes</a>
  }

  state = {
    btn: null
  }

  buttonRef = (btn) => {
    this.setState({ btn })
  }
  renderProps = ({ onSave, onDelete, isLoading, notes, ...props }) => {
    let content;
    if (!sessionStore.sessionLoaded || isLoading) {
      content = (
        <div>
          <Spinner size="sm" />
        </div>
      );
    } else {
      content = (
        <Notes
          onDelete={onDelete}
          onSave={onSave}
          noteData={notes}
          user={sessionStore.user}
        />
      );
    }

    const Button = this.props.button;
    return (
      <span>
        {this.state.btn && <UncontrolledPopover placement="top" target={this.state.btn}>
          <PopoverHeader>Notes</PopoverHeader>
          <PopoverBody>{content}</PopoverBody>
        </UncontrolledPopover>}
        <span ref={this.buttonRef} >{Button({ isLoading, notes })}</span>
      </span>
    );
  };

  render() {
    return <WithNoteData
      noteType={this.props.noteType}
      entityId={this.props.entityId}
      filters={this.props.filters}
      render={this.renderProps}/>
  }
}